import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

export default function ProjectRepositoryPreviewDialog({ preview, onClose, onDownload }) {
    const open = Boolean(preview?.url);
    const isImage = String(preview?.contentType || '').startsWith('image/');
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg" PaperProps={{ sx: { height: { xs: '90vh', md: '86vh' }, borderRadius: 2 } }}>
            <DialogTitle sx={{ fontWeight: 900, overflowWrap: 'anywhere' }}>{preview?.name || 'Document preview'}</DialogTitle>
            <DialogContent dividers sx={{ p: 0, bgcolor: 'background.default', display: 'grid', placeItems: 'center' }}>
                {isImage ? (
                    <Box component="img" src={preview?.url} alt={preview?.name || 'Document'} sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                ) : (
                    <Box component="iframe" title={preview?.name || 'Document preview'} src={preview?.url} sx={{ width: '100%', height: '100%', border: 0, bgcolor: 'background.paper' }} />
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onDownload(preview.file)}>Download</Button>
                <Button variant="contained" onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}